import { render, staticRenderFns } from "./NavbarSocialLink.vue?vue&type=template&id=2609f3b7&scoped=true&"
import script from "./NavbarSocialLink.vue?vue&type=script&lang=js&"
export * from "./NavbarSocialLink.vue?vue&type=script&lang=js&"
import style0 from "./NavbarSocialLink.vue?vue&type=style&index=0&id=2609f3b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2609f3b7",
  null
  
)

export default component.exports